import CardCarrier from './CardCarrier';

export default CardCarrier;
